// Exports
export default {
	"Theme_color_orb-migrate-dark": "Theme_color_orb-migrate-dark"
};
